import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_TypeConversions = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Type Conversions in C"
    videos={[
      "https://www.youtube.com/embed/gWti7GG8igc", // Type Conversion in C
    ]}
    takeaways={[
      { text: "Understand how operations between different data types result in specific data types." },
      { text: "Learn to avoid data loss during typecasting by using compatible type casting." },
      { text: "Memorize how implicit and explicit conversions work in C." },
      { image: '/Oopstypeconversions.png'}
    ]}
    questions={[
      "How do operations between different types of operands work in C?",
      "Explain implicit and explicit type conversions with examples.",
      "How can you prevent data loss during typecasting?",
    ]}
    exampleVideos={[]} // Add any practice or demo videos if needed
  />
);
}

export default OOPS_M1_TypeConversions;
